import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7973e22b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form__footer" }
const _hoisted_2 = { class: "character-count" }
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _withDirectives(_createElementVNode("textarea", {
      required: "",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
      placeholder: "Escreva uma anotação...",
      maxlength: "500",
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 544), [
      [_vModelText, _ctx.input]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.input.length) + " / 500", 1),
      _createElementVNode("button", {
        disabled: _ctx.input.trim() === '',
        class: _normalizeClass({disabled: _ctx.input.trim() === ''}),
        type: "submit"
      }, " Salvar anotação ", 10, _hoisted_3)
    ])
  ], 32))
}